(() => {
  const carouselSelector = '[data-dpn-app-carousel]';

  function initializeCarousel(carousel) {
    if (carousel.dataset.dpnCarouselInitialized === 'true') return;

    const slides = Array.from(carousel.querySelectorAll('[data-dpn-slide]'));
    const dots = Array.from(carousel.querySelectorAll('[data-dpn-carousel-dot]'));
    const previousButton = carousel.querySelector('[data-dpn-carousel-previous]');
    const nextButton = carousel.querySelector('[data-dpn-carousel-next]');
    const status = carousel.querySelector('[data-dpn-carousel-status]');

    if (!slides.length || slides.length !== dots.length || !previousButton || !nextButton || !status) return;

    const autoplayDelay = Number(carousel.dataset.autoplayDelay) || 5000;
    let activeIndex = 0;
    let pointerStartX = null;
    let timer = null;

    carousel.dataset.dpnCarouselInitialized = 'true';

    const normalize = (index) => (index + slides.length) % slides.length;

    function positionFor(index) {
      const delta = normalize(index - activeIndex);
      if (delta === 0) return 'active';
      if (delta === 1) return 'next';
      if (delta === slides.length - 1) return 'previous';
      return 'far';
    }

    function updateCarousel(announce = true) {
      slides.forEach((slide, index) => {
        const position = positionFor(index);
        slide.dataset.position = position;
        slide.setAttribute('aria-hidden', position === 'far' ? 'true' : 'false');
        slide.tabIndex = position === 'far' ? -1 : 0;
      });

      dots.forEach((dot, index) => {
        if (index === activeIndex) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });

      if (announce) {
        status.textContent = `Image ${activeIndex + 1} of ${slides.length}: ${slides[activeIndex].getAttribute('aria-label')}`;
      }
    }

    function goTo(index, announce = true) {
      activeIndex = normalize(index);
      updateCarousel(announce);
    }

    function stopAutoplay() {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    }

    function startAutoplay() {
      stopAutoplay();
      if (document.hidden) return;
      timer = window.setInterval(() => goTo(activeIndex + 1, false), autoplayDelay);
    }

    function restartAutoplay() {
      startAutoplay();
    }

    previousButton.addEventListener('click', () => {
      goTo(activeIndex - 1);
      restartAutoplay();
    });

    nextButton.addEventListener('click', () => {
      goTo(activeIndex + 1);
      restartAutoplay();
    });

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        goTo(index);
        restartAutoplay();
      });
    });

    slides.forEach((slide, index) => {
      slide.addEventListener('click', () => {
        if (index === activeIndex) return;
        goTo(index);
        restartAutoplay();
      });
    });

    carousel.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        goTo(activeIndex - 1);
        restartAutoplay();
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        goTo(activeIndex + 1);
        restartAutoplay();
      }
    });

    carousel.addEventListener('pointerdown', (event) => {
      pointerStartX = event.clientX;
    });

    carousel.addEventListener('pointerup', (event) => {
      if (pointerStartX === null) return;
      const distance = event.clientX - pointerStartX;
      pointerStartX = null;
      if (Math.abs(distance) < 44) return;
      goTo(activeIndex + (distance < 0 ? 1 : -1));
      restartAutoplay();
    });

    carousel.addEventListener('pointercancel', () => {
      pointerStartX = null;
    });

    function handleVisibilityChange() {
      restartAutoplay();
    }

    document.addEventListener('visibilitychange', handleVisibilityChange);

    carousel.dpnCarouselDestroy = () => {
      stopAutoplay();
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      delete carousel.dataset.dpnCarouselInitialized;
    };

    updateCarousel(false);
    startAutoplay();
  }

  function initializeWithin(root = document) {
    if (root.matches?.(carouselSelector)) initializeCarousel(root);
    root.querySelectorAll?.(carouselSelector).forEach(initializeCarousel);
  }

  initializeWithin();

  document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const carousel = event.target.matches?.(carouselSelector)
      ? event.target
      : event.target.querySelector?.(carouselSelector);
    carousel?.dpnCarouselDestroy?.();
  });
})();
